// import * as Yup from "yup-phone"
import * as Yup from "yup";
import { Strong_Password } from "./ValidationFunctions";

export const validationSchema = Yup.object({
  username: Yup.lazy((value) => {
    if (isNaN(parseInt(value)) && value !== undefined) {
      return Yup.string().email("ایمیل را صحیح وارد کنید");
    }

    return Yup.string()
      .matches(
        "^[0][9][0-9]{9}$" || "^[۰][۹][۰-۹]{9}$",
        "شماره اشتباه است (09xxxx)"
      )
      .required("شماره موبایل یا ایمیل خود را وارد کنید");
  }),

  password: Yup.string()
    .required("پسورد را وارد کنید")
    .matches(
      Strong_Password,
      "پسورد حداقل 8 کاراکتر و شامل حروف کوچک،بزرگ،اعداد  و (@،!،%،..)است"
    ),
});

export const initialValue = {
  username: "",
  password: "",
};
